module.exports = __webpack_public_path__ + "img/1724249229854-IMG_1519.jpeg.fee3de93.webp";